import React, { useState } from 'react';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { Button, TextField, Grid, Typography } from '@mui/material';

import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';

const TransferDialogue = (props) => {
       const [organization, setOrganization] = useState('')
        
        const handleChange = (event) => {
          setOrganization(event.target.value);
        };
       
       return (<Dialog
        open={props.open}
        onclose={() => props.clear()}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          Transfer Case 
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="request-docs-alert-dialog-description">
            You may transfer this case to another organization. This cannnot be undone with an administrator's help.
          <FormControl fullWidth sx={{mt: 2}} >
            <InputLabel id="demo-simple-select-label">Select who this case should be transfered to.</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={organization}
              label="Organiation"
              onChange={handleChange}
            >
              <MenuItem value={1}>Dev</MenuItem>
              <MenuItem value={2}>Gallo Law</MenuItem>
              <MenuItem value={3}>OLG</MenuItem>
              <MenuItem value={4}>Leads</MenuItem>
            </Select>
          </FormControl>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => props.clear()}>Cancel</Button>
          <Button color={'primary'} onClick={() => { props.clear(); props.onAction(organization); }} autofocus>
            Confirm Transfer 
          </Button>
        </DialogActions>
      </Dialog>)
}
export default TransferDialogue;

